import { __awaiter, __generator } from "tslib";
import { fetchSharedContext } from '@office-start/context-service';
import { hasDownloadCapability } from '@office-start/file-utility';
import { fetchDriveItem } from '@office-start/graph-service';
import { logGenericEvent } from '@office-start/instrumentation-service';
import { KnownInstrumentationEvents, } from '@office-start/instrumentation-types';
import { launchUrl } from '@office-start/launcher-service';
import { logError } from '@office-start/telemetry-service';
import { removeQueryParams } from '@office-start/url-parser-utility';
export function createDownloadAction(item, componentContext) {
    var _this = this;
    if (!hasDownloadCapability(item)) {
        return undefined;
    }
    if (!item.downloadUrl) {
        return undefined;
    }
    if (!componentContext) {
        return undefined;
    }
    var targetUrl = item.downloadUrl;
    return function () { return __awaiter(_this, void 0, void 0, function () {
        var action, driveId, docId, sharedContext, driveItem, e_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    action = 'Download';
                    if (!(item.driveId && item.docId)) return [3 /*break*/, 5];
                    driveId = item.driveId, docId = item.docId;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetchSharedContext()];
                case 2:
                    sharedContext = _b.sent();
                    if (!sharedContext) {
                        throw new Error('Invalid sharedContext');
                    }
                    return [4 /*yield*/, fetchDriveItem({
                            driveId: driveId,
                            itemId: docId,
                            graphXhrOptions: {
                                correlationId: componentContext.correlationId,
                                getAccessToken: componentContext.getAccessToken,
                                jwtAuthEnabled: componentContext.jwtAuthEnabled,
                                officeApiRoot: componentContext.officeHomeApiRoot,
                                graphApiRoot: sharedContext.graphApiRoot,
                            },
                            queryParams: {
                                select: ['id', 'content.downloadUrl'].join(','),
                            },
                        })];
                case 3:
                    driveItem = _b.sent();
                    if (!driveItem['@microsoft.graph.downloadUrl']) {
                        throw new Error('Missing downloadUrl');
                    }
                    targetUrl = removeQueryParams(driveItem['@microsoft.graph.downloadUrl'], ['tempAuth', 'ApiVersion']);
                    return [3 /*break*/, 5];
                case 4:
                    e_1 = _b.sent();
                    logGenericEvent(KnownInstrumentationEvents.GetDownloadUrlError, (_a = {},
                        _a["Error" /* InstrumentationParam.Error */] = (e_1 === null || e_1 === void 0 ? void 0 : e_1.toString()) || '',
                        _a));
                    logError({
                        eventName: 'Get_DownloadUrl_Error',
                        message: (e_1 === null || e_1 === void 0 ? void 0 : e_1.toString()) || '',
                    });
                    return [3 /*break*/, 5];
                case 5: return [4 /*yield*/, launchUrl(targetUrl, { action: action })];
                case 6:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    }); };
}
//# sourceMappingURL=createDownloadAction.js.map